var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNegotiations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 4.16667H5.83329C5.39127 4.16667 4.96734 4.34226 4.65478 4.65482C4.34222 4.96738 4.16663 5.39131 4.16663 5.83333V15.8333C4.16663 16.2754 4.34222 16.6993 4.65478 17.0118C4.96734 17.3244 5.39127 17.5 5.83329 17.5H14.1666C14.6087 17.5 15.0326 17.3244 15.3451 17.0118C15.6577 16.6993 15.8333 16.2754 15.8333 15.8333V5.83333C15.8333 5.39131 15.6577 4.96738 15.3451 4.65482C15.0326 4.34226 14.6087 4.16667 14.1666 4.16667H12.5M7.49996 4.16667C7.49996 4.60869 7.67555 5.03262 7.98812 5.34518C8.30068 5.65774 8.7246 5.83333 9.16663 5.83333H10.8333C11.2753 5.83333 11.6992 5.65774 12.0118 5.34518C12.3244 5.03262 12.5 4.60869 12.5 4.16667M7.49996 4.16667C7.49996 3.72464 7.67555 3.30072 7.98812 2.98816C8.30068 2.67559 8.7246 2.5 9.16663 2.5H10.8333C11.2753 2.5 11.6992 2.67559 12.0118 2.98816C12.3244 3.30072 12.5 3.72464 12.5 4.16667M9.99996 10H12.5M9.99996 13.3333H12.5M7.49996 10H7.50829M7.49996 13.3333H7.50829",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNegotiations);
export default __webpack_public_path__ + "static/media/icon_negotiations.9f11d6f2ac7edd8edeef72585dd42317.svg";
export { ForwardRef as ReactComponent };